import React from 'react'
import Text, { TextScale, TextCase } from 'particles/Text'
import MenuItem, { menuItemClasses } from '@mui/material/MenuItem'
import styled from 'particles/themes/styled'
import { BaseMenuItemProps, MenuItemSize } from '.'

const sizeMap: Record<MenuItemSize, { textScale: TextScale }> = {
    m: {
        textScale: 'bodyS500',
    },
    s: {
        textScale: 'caption500',
    },
}

interface MenuItemProps extends BaseMenuItemProps {
    text: string
    case?: TextCase
}

const StyledMenuItem = styled(MenuItem)`
    &.${menuItemClasses.root} {
        font-family: inherit;
        padding: 0;
        &.${menuItemClasses.disabled} {
            opacity: 1;
        }
        .title {
            white-space: pre-wrap;
        }
    }
`

const MenuItemTitle: React.FC<MenuItemProps> = ({ text, size = 's', case: textCase, ...props }) => {
    const { textScale } = sizeMap[size]
    return (
        <StyledMenuItem {...props} disabled>
            <Text scale={textScale} color="tertiary" className="title" case={textCase}>
                {text}
            </Text>
        </StyledMenuItem>
    )
}

export default MenuItemTitle
